import CampaignReportsActionTypes from './types';

const initialState = {
  campaignGiftReports: [],
  isFetchingCampaignGifts: false,
  giftWinners: [],
  isFetchingGiftWinners: false,
  isExportingCoupons: false,
};

const reportsReducer = (state = initialState, action) => {
  const { payload, type } = action;

  switch (type) {
    case CampaignReportsActionTypes.SET_CAMPAIGN_REPORTS_STATE: {
      return { ...state, ...payload };
    }
    case CampaignReportsActionTypes.FETCH_CAMPAIGN_GIFT_REPORTS_START: {
      return { ...state, isFetchingCampaignGifts: true };
    }
    case CampaignReportsActionTypes.EXPORT_COUPONS_START: {
      return { ...state, isExportingCoupons: true };
    }
    case CampaignReportsActionTypes.FETCH_CAMPAIGN_GIFT_REPORTS_SUCCESS: {
      return { ...state, campaignGiftReports: payload };
    }
    case CampaignReportsActionTypes.FETCH_GIFT_WINNERS_START: {
      return { ...state, isFetchingGiftWinners: true };
    }
    case CampaignReportsActionTypes.FETCH_GIFT_WINNERS_SUCCESS: {
      return { ...state, giftWinners: payload };
    }
    default: {
      return state;
    }
  }
};

export default reportsReducer;
